<form [formGroup]="form" novalidate (ngSubmit)="submitValues()">
  <mat-form-field>
      <input matInput
              (input)="forcePlaceholder($event)"
              [formControl]="from"
              [errorStateMatcher]="matcher"
              placeholder="{{ 'SEARCH.FILTER.RANGE.FROM-DATE' | translate }}"
              [matDatepicker]="fromDatepicker"
              [max]="fromMaxDate"
              (dateChange)="onChangedHandler($event, from)"
              data-automation-id="date-range-from-input">
      <mat-datepicker-toggle matSuffix [for]="fromDatepicker" data-automation-id="date-range-from-date-toggle"></mat-datepicker-toggle>
      <mat-datepicker #fromDatepicker color="accent"></mat-datepicker>
      <mat-error *ngIf="from.invalid" data-automation-id="date-range-from-error">
          {{ getFromValidationMessage() | translate: { requiredFormat: datePickerFormat } }}
      </mat-error>
  </mat-form-field>

  <mat-form-field>
      <input matInput
              (input)="forcePlaceholder($event)"
              [formControl]="to"
              [errorStateMatcher]="matcher"
              placeholder="{{ 'SEARCH.FILTER.RANGE.TO-DATE' | translate }}"
              [matDatepicker]="toDatepicker"
              [min]="from.value"
              [max]="maxDate"
              (dateChange)="onChangedHandler($event, to)"
              data-automation-id="date-range-to-input">
      <mat-datepicker-toggle  matSuffix [for]="toDatepicker" data-automation-id="date-range-to-date-toggle"></mat-datepicker-toggle>
      <mat-datepicker #toDatepicker color="accent"></mat-datepicker>
      <mat-error *ngIf="to.invalid" data-automation-id="date-range-to-error">
          {{ getToValidationMessage() | translate: { requiredFormat: datePickerFormat } }}
      </mat-error>
  </mat-form-field>
  
  <div class="adf-facet-buttons adf-facet-buttons--topSpace" *ngIf="!settings?.hideDefaultAction && editable">
      <button mat-button color="primary" type="button" (click)="reset()" data-automation-id="date-range-clear-btn">
          {{ 'SEARCH.FILTER.ACTIONS.CLEAR' | translate }}
      </button>
      <button mat-button color="primary" type="submit" [disabled]="!hasValidValue()" data-automation-id="date-range-apply-btn">
          {{ 'SEARCH.FILTER.ACTIONS.APPLY' | translate }}
      </button>
  </div>
</form>

<mat-slide-toggle *ngIf="nullable" [(ngModel)]="filterIsNull">{{'ALDEN.CUSTOM_LISTS.FILTERS.IS_NULL' | translate}}</mat-slide-toggle>